import ApplicationConstants from "@certn/application/src/constants";
import FormConstants from "@certn/forms/src/constants";

import { getServerEnvironment } from "./src/config";

const constants = import.meta.env || {};

export const IS_LOCALHOST = window.location.hostname === "localhost";

export default constants;

const env = getServerEnvironment();
export const DOMAIN = env.domainUrl;
export const AUTH0_AUDIENCE = env.auth0AudienceUrl;
export const AUTH0_CALLBACK_URL = env.auth0CallbackUrl;
export const USE_WATERMARKS_ON_REPORTS = env.useWatermarksOnReports;
export const STRIPE_CERTN_CANADA_PUBLISHABLE_KEY =
  env.stripeCertnCanadaPublishableKey;
export const STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY =
  env.stripeCertnCanadaPrepayPublishableKey;
export const STRIPE_CERTN_USA_PUBLISHABLE_KEY =
  env.stripeCertnUsaPublishableKey;
export const STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY =
  env.stripeCertnUsaPrepayPublishableKey;
export const STRIPE_CERTN_UK_PUBLISHABLE_KEY = env.stripeCertnUkPublishableKey;
export const STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY =
  env.stripeCertnUkPrepayPublishableKey;
export const STRIPE_INTERCHECK_PUBLISHABLE_KEY =
  env.stripeCertnIntercheckPublishableKey;
export const STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY =
  env.stripeIntercheckPrepayPublishableKey;
export const STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY =
  env.stripeIntercheckConsumerPublishableKey;

if (constants.VITE_ENABLE_DEMO_RESPONSES === "true") {
  ApplicationConstants.enableDemoResponses = true;
}
if (constants.VITE_CASCADIA_FORMS_DEBUG_MODE === "true") {
  FormConstants.debug = true;
}
